// PageRenderer - Dynamic CMS page renderer
import { useParams } from 'react-router-dom';

export default function PageRenderer() {
  const { slug } = useParams();
  return <div><h1 className="text-4xl font-bold text-center py-20 capitalize">{slug?.replace('-', ' ')}</h1></div>;
}